import {z} from 'zod';
import {zDateTime} from '@brunata-angular/util';

const consumptionSchema = z.object({
    fromDate: zDateTime,
    toDate: zDateTime,
    consumption: z.number().nullable(),
});

export const consumptionReportDetailsSchema = z
    .object({
        buildingNo: z.number().nullable(),
        buildingName: z.string().nullable(),
        propertyNo: z.string().nullable(),
        branchNo: z.string().nullable(),
        locationNo: z.string().nullable(),
        address: z.string().nullable(),
        meterSequenceNo: z.number().nullable(),
        alloUnitType: z.string(),
        meterNo: z.string().nullable(),
        placement: z.string().nullable(),
        meterType: z.number(),
        unit: z.number(),
        mountingDate: zDateTime.nullable(),
        consumptions: z.array(consumptionSchema),
    })
    .transform(data => ({
        ...data,
        proBraLoc: `${data.propertyNo}-${data.branchNo}-${data.locationNo}`,
    }));

export type ConsumptionReportDetails = z.infer<typeof consumptionReportDetailsSchema>;
